/** Cloudflare RealtimeKit preset for livestream hosts (webinar presenter). */
export const RTK_HOST_PRESET = "webinar_presenter";

export const RTK_HIGH_QUALITY_AUDIO = {
  enableHighBitrate: true,
  enableStereo: true,
} as const;

export const HOST_AUDIO_CAPTURE_CONSTRAINTS: MediaTrackConstraints = {
  channelCount: { ideal: 2 },
  sampleRate: { ideal: 48000 },
  echoCancellation: false,
  noiseSuppression: false,
  autoGainControl: false,
  // Chromium-specific overrides to ensure raw audio pass-through
  googEchoCancellation: false,
  googAutoGainControl: false,
  googNoiseSuppression: false,
  googHighpassFilter: false,
};
